import React from 'react';
import BioExpand from "./BioExpand";

export default function TeamAccordion(props) {
    const { teamMembers } = props;

    const cards = teamMembers.map((teamMember, index) => (
        <BioExpand key={index} rightJustify={index % 2 !== 0} teamMember={teamMember} />
    ));

    return (
        <div>
            {cards}
        </div>
    );
}
    import { render } from 'react-dom'                                    
    if (window.reactComponents === undefined) {                           
      window.reactComponents = {}                                         
    }                                                                     
    window.reactComponents.undefined = (function() {                   
    let _args = {}                                                        
                                                                          
    return {                                                              
      init: function (Args) {                                             
        _args = Args                                                      
      },                                                                  
      render: function () {                                               
        const  { id, ...props } = JSON.parse(_args)                       
        render(<undefined {...props}/>, document.getElementById(id))   
      }                                                                   
    }                                                                     
  }())